import { AlarmsParamsBaseModel } from './Alarms';
import { FiltersPeriodModel } from './Filters';
import { HistoryParamsBaseModel } from './History';

// - - - GENERAL - - -

export enum BaseExportType {
  CSV = 'Csv',
  Text = 'Text',
}

// - - - GRAPH - - -

export enum GraphExportDataType {
  Data = 'data',
  Summary = 'summary',
}

export enum GraphCustomExportType {
  Json = 'Json',
  JsonMeter = 'JsonMeter',
  SDX = 'SDX',
  SBS = 'SBS',
  UU = 'UU',
  YW = 'YW',
  STW = 'STW',
}

export enum OptionalExportType {
  StateEvent = 'StateEvent'
}

export type GraphExportType = BaseExportType | GraphCustomExportType | OptionalExportType;

// - - - HISTORY and ALARMS - - -

export interface HistoryAndAlarmsGetExportModel {
  siteIds: string[];
  dataType: BaseExportType;
}

// - - - ALARMS - - -

export interface AlarmsGetExportModel
  extends AlarmsParamsBaseModel,
    HistoryAndAlarmsGetExportModel,
    FiltersPeriodModel {}

export interface AlarmsExportParamsModel extends AlarmsParamsBaseModel, FiltersPeriodModel {}

// - - - HISTORY - - -

export interface HistoryGetExportModel
  extends HistoryParamsBaseModel,
    HistoryAndAlarmsGetExportModel,
    FiltersPeriodModel {}

export interface HistoryExportParamsModel extends HistoryParamsBaseModel, FiltersPeriodModel {}
